import { render, staticRenderFns } from "./viewCRMGallery.vue?vue&type=template&id=1fbed96a"
import script from "./viewCRMGallery.vue?vue&type=script&lang=js"
export * from "./viewCRMGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports